import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { array_type, list_type, float64_type, union_type, bool_type, int32_type, class_type, uint8_type, int16_type, record_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { InvoiceeType$reflection, Distribution$reflection } from "../../DomainTypes.js";
import { ClientUnpaidInvoiceReminderSetting$reflection, ClientInvoiceFee$reflection, LoadState$2$reflection, GlobalDependencies$reflection } from "../../Global.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";

export class ClientSettingJson extends Record {
    constructor(SettingId, Value) {
        super();
        this.SettingId = SettingId;
        this.Value = Value;
    }
}

export function ClientSettingJson$reflection() {
    return record_type("Containers.ClientSettings.Model.ClientSettingJson", [], ClientSettingJson, () => [["SettingId", option_type(string_type)], ["Value", option_type(string_type)]]);
}

export class WarningMessage extends Record {
    constructor(ValidateMessage) {
        super();
        this.ValidateMessage = ValidateMessage;
    }
}

export function WarningMessage$reflection() {
    return record_type("Containers.ClientSettings.Model.WarningMessage", [], WarningMessage, () => [["ValidateMessage", string_type]]);
}

export class InvoiceCalendar extends Record {
    constructor(Year, Month, InvoiceDate, InvoiceRunDate) {
        super();
        this.Year = (Year | 0);
        this.Month = Month;
        this.InvoiceDate = InvoiceDate;
        this.InvoiceRunDate = InvoiceRunDate;
    }
}

export function InvoiceCalendar$reflection() {
    return record_type("Containers.ClientSettings.Model.InvoiceCalendar", [], InvoiceCalendar, () => [["Year", int16_type], ["Month", uint8_type], ["InvoiceDate", class_type("System.DateTime")], ["InvoiceRunDate", option_type(class_type("System.DateTime"))]]);
}

export class FrozenMonthFeeDescription extends Record {
    constructor(FeeDescription) {
        super();
        this.FeeDescription = FeeDescription;
    }
}

export function FrozenMonthFeeDescription$reflection() {
    return record_type("Containers.ClientSettings.Model.FrozenMonthFeeDescription", [], FrozenMonthFeeDescription, () => [["FeeDescription", string_type]]);
}

export class CampaignCode extends Record {
    constructor(CampaignCode, CampaignCodeDescription) {
        super();
        this.CampaignCode = CampaignCode;
        this.CampaignCodeDescription = CampaignCodeDescription;
    }
}

export function CampaignCode$reflection() {
    return record_type("Containers.ClientSettings.Model.CampaignCode", [], CampaignCode, () => [["CampaignCode", string_type], ["CampaignCodeDescription", string_type]]);
}

export class FrozenMonthConfigurationJsonModel extends Record {
    constructor(Name, ProductNr) {
        super();
        this.Name = Name;
        this.ProductNr = (ProductNr | 0);
    }
}

export function FrozenMonthConfigurationJsonModel$reflection() {
    return record_type("Containers.ClientSettings.Model.FrozenMonthConfigurationJsonModel", [], FrozenMonthConfigurationJsonModel, () => [["Name", string_type], ["ProductNr", int32_type]]);
}

export class UnpaidInvoiceReminderSetting extends Record {
    constructor(ReminderDaysAfterDueDate, IncludeOnAutogiro, SMSTemplate, EmailSubjectTemplate, EmailBodyTemplate, BeforeReminderDaysAfterDueDate) {
        super();
        this.ReminderDaysAfterDueDate = (ReminderDaysAfterDueDate | 0);
        this.IncludeOnAutogiro = IncludeOnAutogiro;
        this.SMSTemplate = SMSTemplate;
        this.EmailSubjectTemplate = EmailSubjectTemplate;
        this.EmailBodyTemplate = EmailBodyTemplate;
        this.BeforeReminderDaysAfterDueDate = (BeforeReminderDaysAfterDueDate | 0);
    }
}

export function UnpaidInvoiceReminderSetting$reflection() {
    return record_type("Containers.ClientSettings.Model.UnpaidInvoiceReminderSetting", [], UnpaidInvoiceReminderSetting, () => [["ReminderDaysAfterDueDate", int32_type], ["IncludeOnAutogiro", bool_type], ["SMSTemplate", string_type], ["EmailSubjectTemplate", string_type], ["EmailBodyTemplate", string_type], ["BeforeReminderDaysAfterDueDate", int32_type]]);
}

export class InvoiceFee extends Record {
    constructor(DistributionCode, Description, IncludeFeeOnAutogiroVarsel, PriceExclVat, VatRatePercent, InvoiceeType, Kontonummer) {
        super();
        this.DistributionCode = DistributionCode;
        this.Description = Description;
        this.IncludeFeeOnAutogiroVarsel = IncludeFeeOnAutogiroVarsel;
        this.PriceExclVat = PriceExclVat;
        this.VatRatePercent = VatRatePercent;
        this.InvoiceeType = InvoiceeType;
        this.Kontonummer = Kontonummer;
    }
}

export function InvoiceFee$reflection() {
    return record_type("Containers.ClientSettings.Model.InvoiceFee", [], InvoiceFee, () => [["DistributionCode", Distribution$reflection()], ["Description", string_type], ["IncludeFeeOnAutogiroVarsel", bool_type], ["PriceExclVat", string_type], ["VatRatePercent", string_type], ["InvoiceeType", option_type(InvoiceeType$reflection())], ["Kontonummer", string_type]]);
}

export class InvoiceCalendarEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeYear", "OnChangeMonth", "OnChangeInvoiceDate", "OnChangeInvoiceRunDate"];
    }
}

export function InvoiceCalendarEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.InvoiceCalendarEvent", [], InvoiceCalendarEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", class_type("System.DateTime")]], [["Item", option_type(class_type("System.DateTime"))]]]);
}

export class ClientUnpaidInvoiceReminderSettingEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeSMSTemplate", "OnChangeIncludeOnAutogiro", "OnChangeEmailSubjectTemplate", "OnChangeEmailBodyTemplate", "OnChangeReminderDaysAfterDueDate"];
    }
}

export function ClientUnpaidInvoiceReminderSettingEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.ClientUnpaidInvoiceReminderSettingEvent", [], ClientUnpaidInvoiceReminderSettingEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class InvoiceFeeEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeDistributionCode", "OnChangeDescription", "OnChangeIncludeFeeOnAutogiroVarsel", "OnChangePriceExclVat", "OnChangeVatRatePercent", "OnChangeInvoiceeType", "OnChangeKontonummer"];
    }
}

export function InvoiceFeeEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.InvoiceFeeEvent", [], InvoiceFeeEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class CustomerGroupEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeCustomerGroupCode", "OnChangeCustomerGroupName"];
    }
}

export function CustomerGroupEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.CustomerGroupEvent", [], CustomerGroupEvent, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export class ObjectCodeEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeClientObjectNr", "OnChangeObjectDescription"];
    }
}

export function ObjectCodeEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.ObjectCodeEvent", [], ObjectCodeEvent, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export class AccountNoEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeAccountNo", "OnChangeAccountDescription", "OnChangeAccountCostCentre"];
    }
}

export function AccountNoEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.AccountNoEvent", [], AccountNoEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class CampaignCodeEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeCampaignCode", "OnChangeCampaignCodeDescription"];
    }
}

export function CampaignCodeEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.CampaignCodeEvent", [], CampaignCodeEvent, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export class FrozenMonthFeeDescriptionEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeFeeDescription"];
    }
}

export function FrozenMonthFeeDescriptionEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.FrozenMonthFeeDescriptionEvent", [], FrozenMonthFeeDescriptionEvent, () => [[["Item", string_type]]]);
}

export class ObjectCode extends Record {
    constructor(ClientObjectNr, ObjectDescription) {
        super();
        this.ClientObjectNr = (ClientObjectNr | 0);
        this.ObjectDescription = ObjectDescription;
    }
}

export function ObjectCode$reflection() {
    return record_type("Containers.ClientSettings.Model.ObjectCode", [], ObjectCode, () => [["ClientObjectNr", int32_type], ["ObjectDescription", string_type]]);
}

export class CustomerGroup extends Record {
    constructor(CustomerGroupCode, CustomerGroupName) {
        super();
        this.CustomerGroupCode = (CustomerGroupCode | 0);
        this.CustomerGroupName = CustomerGroupName;
    }
}

export function CustomerGroup$reflection() {
    return record_type("Containers.ClientSettings.Model.CustomerGroup", [], CustomerGroup, () => [["CustomerGroupCode", int32_type], ["CustomerGroupName", string_type]]);
}

export class AccountNo extends Record {
    constructor(AccountNo, Description, CostCentre) {
        super();
        this.AccountNo = AccountNo;
        this.Description = Description;
        this.CostCentre = CostCentre;
    }
}

export function AccountNo$reflection() {
    return record_type("Containers.ClientSettings.Model.AccountNo", [], AccountNo, () => [["AccountNo", class_type("System.Decimal")], ["Description", string_type], ["CostCentre", string_type]]);
}

export class Modal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nothing", "Create", "Edit"];
    }
}

export function Modal$reflection() {
    return union_type("Containers.ClientSettings.Model.Modal", [], Modal, () => [[], [], []]);
}

export class ClientSetting extends Record {
    constructor(SettingGroup, SettingId, DisplayName, Value, UseDefaultValue, DefaultValue, Description) {
        super();
        this.SettingGroup = SettingGroup;
        this.SettingId = SettingId;
        this.DisplayName = DisplayName;
        this.Value = Value;
        this.UseDefaultValue = UseDefaultValue;
        this.DefaultValue = DefaultValue;
        this.Description = Description;
    }
}

export function ClientSetting$reflection() {
    return record_type("Containers.ClientSettings.Model.ClientSetting", [], ClientSetting, () => [["SettingGroup", string_type], ["SettingId", string_type], ["DisplayName", string_type], ["Value", string_type], ["UseDefaultValue", bool_type], ["DefaultValue", string_type], ["Description", string_type]]);
}

export class SettingModel extends Record {
    constructor(ClientNr, ErrorMessage, IsEditingSetting, SettingViewModel, SettingModel, IsAdvanceSetting) {
        super();
        this.ClientNr = ClientNr;
        this.ErrorMessage = ErrorMessage;
        this.IsEditingSetting = IsEditingSetting;
        this.SettingViewModel = SettingViewModel;
        this.SettingModel = SettingModel;
        this.IsAdvanceSetting = IsAdvanceSetting;
    }
}

export function SettingModel$reflection() {
    return record_type("Containers.ClientSettings.Model.SettingModel", [], SettingModel, () => [["ClientNr", option_type(int32_type)], ["ErrorMessage", option_type(string_type)], ["IsEditingSetting", bool_type], ["SettingViewModel", option_type(ClientSetting$reflection())], ["SettingModel", ClientSetting$reflection()], ["IsAdvanceSetting", bool_type]]);
}

export class AdvanceSettingEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SettingOn", "SettingOff"];
    }
}

export function AdvanceSettingEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.AdvanceSettingEvent", [], AdvanceSettingEvent, () => [[["Item", SettingModel$reflection()]], [["Item", SettingModel$reflection()]]]);
}

export class EditSettingEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeValue", "EditSetting", "SaveSetting", "CancelSetting"];
    }
}

export function EditSettingEvent$reflection() {
    return union_type("Containers.ClientSettings.Model.EditSettingEvent", [], EditSettingEvent, () => [[["Item1", SettingModel$reflection()], ["Item2", string_type]], [["Item", SettingModel$reflection()]], [["Item", SettingModel$reflection()]], [["Item", SettingModel$reflection()]]]);
}

export class CreateInvoiceFeeJsonModel extends Record {
    constructor(DistributionCode, Description, IncludeFeeOnAutogiroVarsel, PriceExclVat, VatRatePercent, InvoiceeType, Kontonummer) {
        super();
        this.DistributionCode = (DistributionCode | 0);
        this.Description = Description;
        this.IncludeFeeOnAutogiroVarsel = IncludeFeeOnAutogiroVarsel;
        this.PriceExclVat = PriceExclVat;
        this.VatRatePercent = VatRatePercent;
        this.InvoiceeType = InvoiceeType;
        this.Kontonummer = (Kontonummer | 0);
    }
}

export function CreateInvoiceFeeJsonModel$reflection() {
    return record_type("Containers.ClientSettings.Model.CreateInvoiceFeeJsonModel", [], CreateInvoiceFeeJsonModel, () => [["DistributionCode", int32_type], ["Description", string_type], ["IncludeFeeOnAutogiroVarsel", bool_type], ["PriceExclVat", float64_type], ["VatRatePercent", float64_type], ["InvoiceeType", string_type], ["Kontonummer", int32_type]]);
}

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SettingGroups", "Setting", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.ClientSettings.Model.Page", [], Page, () => [[], [["Item", string_type]], []]);
}

export class Model extends Record {
    constructor(GlobalDependencies, CurrentClientSettingsPage, ClientSettings, CurrentSettingGroup, ErrorMessage, WarningMessages, OpenNotification, OpenInvoiceFeeModal, OpenObjectCodeModal, OpenCustomerGroupModal, OpenAccountNoModal, OpenUnpaidInvoiceReminderSettingModal, OpenInvoiceCalendarModal, OpenFrozenMonthFeeDescriptionModal, OpenCampaignCodeModal, InvoiceFeeViewModel, ObjectCodeViewModel, CustomerGroupViewModel, AccountNoViewModel, InvoiceCalendarViewModel, UnpaidInvoiceReminderSettingViewModel, FrozenMonthFeeDescriptionViewModel, CampaignCodeViewModel, ClientInvoiceFees, ObjectCodes, CustomerGroups, AccountNumbers, InvoiceCalendars, UnpaidInvoiceReminderSettings, FrozenMonthFeeDescriptions, CampaignCodes) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentClientSettingsPage = CurrentClientSettingsPage;
        this.ClientSettings = ClientSettings;
        this.CurrentSettingGroup = CurrentSettingGroup;
        this.ErrorMessage = ErrorMessage;
        this.WarningMessages = WarningMessages;
        this.OpenNotification = OpenNotification;
        this.OpenInvoiceFeeModal = OpenInvoiceFeeModal;
        this.OpenObjectCodeModal = OpenObjectCodeModal;
        this.OpenCustomerGroupModal = OpenCustomerGroupModal;
        this.OpenAccountNoModal = OpenAccountNoModal;
        this.OpenUnpaidInvoiceReminderSettingModal = OpenUnpaidInvoiceReminderSettingModal;
        this.OpenInvoiceCalendarModal = OpenInvoiceCalendarModal;
        this.OpenFrozenMonthFeeDescriptionModal = OpenFrozenMonthFeeDescriptionModal;
        this.OpenCampaignCodeModal = OpenCampaignCodeModal;
        this.InvoiceFeeViewModel = InvoiceFeeViewModel;
        this.ObjectCodeViewModel = ObjectCodeViewModel;
        this.CustomerGroupViewModel = CustomerGroupViewModel;
        this.AccountNoViewModel = AccountNoViewModel;
        this.InvoiceCalendarViewModel = InvoiceCalendarViewModel;
        this.UnpaidInvoiceReminderSettingViewModel = UnpaidInvoiceReminderSettingViewModel;
        this.FrozenMonthFeeDescriptionViewModel = FrozenMonthFeeDescriptionViewModel;
        this.CampaignCodeViewModel = CampaignCodeViewModel;
        this.ClientInvoiceFees = ClientInvoiceFees;
        this.ObjectCodes = ObjectCodes;
        this.CustomerGroups = CustomerGroups;
        this.AccountNumbers = AccountNumbers;
        this.InvoiceCalendars = InvoiceCalendars;
        this.UnpaidInvoiceReminderSettings = UnpaidInvoiceReminderSettings;
        this.FrozenMonthFeeDescriptions = FrozenMonthFeeDescriptions;
        this.CampaignCodes = CampaignCodes;
    }
}

export function Model$reflection() {
    return record_type("Containers.ClientSettings.Model.Model", [], Model, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentClientSettingsPage", Page$reflection()], ["ClientSettings", LoadState$2$reflection(list_type(ClientSetting$reflection()), string_type)], ["CurrentSettingGroup", list_type(SettingModel$reflection())], ["ErrorMessage", option_type(string_type)], ["WarningMessages", LoadState$2$reflection(list_type(WarningMessage$reflection()), string_type)], ["OpenNotification", bool_type], ["OpenInvoiceFeeModal", Modal$reflection()], ["OpenObjectCodeModal", Modal$reflection()], ["OpenCustomerGroupModal", Modal$reflection()], ["OpenAccountNoModal", Modal$reflection()], ["OpenUnpaidInvoiceReminderSettingModal", Modal$reflection()], ["OpenInvoiceCalendarModal", Modal$reflection()], ["OpenFrozenMonthFeeDescriptionModal", Modal$reflection()], ["OpenCampaignCodeModal", Modal$reflection()], ["InvoiceFeeViewModel", option_type(InvoiceFee$reflection())], ["ObjectCodeViewModel", option_type(ObjectCode$reflection())], ["CustomerGroupViewModel", option_type(CustomerGroup$reflection())], ["AccountNoViewModel", option_type(AccountNo$reflection())], ["InvoiceCalendarViewModel", option_type(InvoiceCalendar$reflection())], ["UnpaidInvoiceReminderSettingViewModel", option_type(UnpaidInvoiceReminderSetting$reflection())], ["FrozenMonthFeeDescriptionViewModel", option_type(FrozenMonthFeeDescription$reflection())], ["CampaignCodeViewModel", option_type(CampaignCode$reflection())], ["ClientInvoiceFees", LoadState$2$reflection(list_type(ClientInvoiceFee$reflection()), string_type)], ["ObjectCodes", LoadState$2$reflection(list_type(ObjectCode$reflection()), string_type)], ["CustomerGroups", LoadState$2$reflection(list_type(CustomerGroup$reflection()), string_type)], ["AccountNumbers", LoadState$2$reflection(list_type(AccountNo$reflection()), string_type)], ["InvoiceCalendars", LoadState$2$reflection(list_type(InvoiceCalendar$reflection()), string_type)], ["UnpaidInvoiceReminderSettings", LoadState$2$reflection(list_type(ClientUnpaidInvoiceReminderSetting$reflection()), string_type)], ["FrozenMonthFeeDescriptions", LoadState$2$reflection(list_type(FrozenMonthFeeDescription$reflection()), string_type)], ["CampaignCodes", LoadState$2$reflection(list_type(CampaignCode$reflection()), string_type)]]);
}

export class ClientSettinglist extends Record {
    constructor(SettingGroup) {
        super();
        this.SettingGroup = SettingGroup;
    }
}

export function ClientSettinglist$reflection() {
    return record_type("Containers.ClientSettings.Model.ClientSettinglist", [], ClientSettinglist, () => [["SettingGroup", string_type]]);
}

export class Intent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LoadSessionContext"];
    }
}

export function Intent$reflection() {
    return union_type("Containers.ClientSettings.Model.Intent", [], Intent, () => [[]]);
}

export class ClientSettingsMsg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PageChanged", "LoadedGlobalDependencies", "LoadSettings", "LoadedSettings", "RouterNavigate", "EditSettingEvent", "SavedClientSetting", "LoadWarningMessage", "LoadedWarningMessage", "LoadNotifications", "CloseNotification", "EditClientInvoiceFee", "RemoveClientInvoiceFee", "EditClientCustomerGroup", "RemoveClientCustomerGroup", "EditClientObjectCode", "RemoveClientObjectCode", "EditClientAccountNo", "RemoveClientAccountNo", "EditClientInvoiceReminderSetting", "RemoveClientInvoiceReminderSetting", "EditInvoiceCalendar", "RemoveInvoiceCalendar", "EditFrozenMonthFee", "RemoveFrozenMonthFee", "EditCampaignCode", "RemoveCampaignCode", "AdvanceSettingEvent", "OpenInvoiceFeeModal", "CloseInvoiceFeeModal", "OpenObjectCodeModal", "CloseObjectCodeModal", "OpenCustomerGroupModal", "CloseCustomerGroupModal", "OpenAccountNoModal", "CloseAccountNoModal", "OpenUnpaidInvoiceReminderSettingModal", "CloseUnpaidInvoiceReminderSettingModal", "OpenInvoiceCalendarModal", "CloseInvoiceCalendarModal", "OpenFrozenMonthFeeModal", "CloseFrozenMonthFeeModal", "OpenCampaignCodeModal", "CloseCampaignCodeModal", "InvoiceFeeEvent", "ObjectCodeEvent", "CustomerGroupEvent", "AccountNoEvent", "InvoiceCalendarEvent", "ClientUnpaidInvoiceReminderSettingEvent", "FrozenMonthFeeEvent", "CampaignCodeEvent", "SaveInvoiceFeeModal", "SaveObjectCodeModal", "SaveCustomerGroupModal", "SaveAccountNoModal", "SaveClientUnpaidInvoiceReminderSettingModal", "SaveInvoiceCalendarModal", "SaveFrozenMonthFeeDescriptionModal", "SaveCampaignCodeModal", "SavedClientInvoiceFee", "SavedClientCustomerGroup", "SavedClientObject", "SavedAccountNo", "SavedClientUnpaidInvoiceReminderSetting", "SavedInvoiceCalendar", "SavedFrozenMonthFeeDescription", "SavedCampaignCode", "SavedFrozenMonthConfiguration", "LoadedClientCustomerGroup", "LoadedClientObject", "LoadedClientInvoiceFees", "LoadedClientAccountNo", "LoadedClientUnpaidInvoiceReminderSetting", "LoadedInvoiceCalendar", "LoadedFrozenMonthFeeDescription", "LoadedCampaignCode", "Intent"];
    }
}

export function ClientSettingsMsg$reflection() {
    return union_type("Containers.ClientSettings.Model.ClientSettingsMsg", [], ClientSettingsMsg, () => [[["Item", Page$reflection()]], [["Item", GlobalDependencies$reflection()]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ClientSetting$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ClientSetting$reflection())]], [["ErrorValue", string_type]]])]], [["Item", array_type(string_type)]], [["Item", EditSettingEvent$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(WarningMessage$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(WarningMessage$reflection())]], [["ErrorValue", string_type]]])]], [], [], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", AdvanceSettingEvent$reflection()]], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [["Item", InvoiceFeeEvent$reflection()]], [["Item", ObjectCodeEvent$reflection()]], [["Item", CustomerGroupEvent$reflection()]], [["Item", AccountNoEvent$reflection()]], [["Item", InvoiceCalendarEvent$reflection()]], [["Item", ClientUnpaidInvoiceReminderSettingEvent$reflection()]], [["Item", FrozenMonthFeeDescriptionEvent$reflection()]], [["Item", CampaignCodeEvent$reflection()]], [], [], [], [], [], [], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(CustomerGroup$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(CustomerGroup$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ObjectCode$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ObjectCode$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ClientInvoiceFee$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ClientInvoiceFee$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(AccountNo$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(AccountNo$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ClientUnpaidInvoiceReminderSetting$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ClientUnpaidInvoiceReminderSetting$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(InvoiceCalendar$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(InvoiceCalendar$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(FrozenMonthFeeDescription$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(FrozenMonthFeeDescription$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(CampaignCode$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(CampaignCode$reflection())]], [["ErrorValue", string_type]]])]], [["Item", Intent$reflection()]]]);
}

export const defaultClientInvoiceFeeKontonummer = "3710";

